import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import Select from '../../../../../components/input/Select';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import Button from '../../../../../components/Button';
import { setDateFormat } from '../../../../../lib/moment';
import {
  addAllItemToSelectList,
  reDirectPage,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  setNumberWithComma,
} from '../../../../../lib/common';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  DISCOUNT_TYPE_TEXT,
  PRODUCT_STATUS_SELECT_LIST,
  PRODUCT_STATUS_TEXT,
} from '../../../../../constants/service/app/productConstants';
import {
  STORE_ACTIVE_STATUS_SELECT_LIST,
  STORE_STATUS_TEXT,
} from '../../../../../constants/service/app/brandConstants';
import {
  PRODUCT_COPY_URL_PATH,
  PRODUCT_DETAIL_URL_PATH,
  PRODUCT_EDIT_URL_PATH,
} from '../../../../../constants/service/common/urlConstants';

/**
 *  상품 전체 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter } = data;

  return [
    {
      Header: '관리',
      fixed: 'left',
      className: 'btn-list',
      Cell: (row) => (
        <>
          <Button
            isRadius
            color="primary"
            text="상세보기"
            onClick={() =>
              reDirectPage({
                path: setDetailPageUrl(PRODUCT_DETAIL_URL_PATH, row.original.productId),
              })
            }
          />
          <Button
            isRadius
            color="gray"
            text="편집하기"
            onClick={() =>
              reDirectPage({
                path: setDetailPageUrl(PRODUCT_EDIT_URL_PATH, row.original.productId),
              })
            }
          />
          <Button
            isRadius
            color="primary"
            text="복사"
            onClick={() =>
              reDirectPage({
                path: setDetailPageUrl(PRODUCT_COPY_URL_PATH, row.original.productId),
              })
            }
          />
        </>
      ),
    },
    {
      accessor: 'url',
      Header: '메인 이미지',
      fixed: 'left',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'productId',
      Header: '상품 ID',
      filterable: true,
      fixed: 'left',
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: 200,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'mainCategory',
      Header: '1차 카테고리',
      width: 120,
    },
    {
      accessor: 'brandName',
      Header: '브랜드',
      filterable: true,
      width: setColumnWidth(list, 'brandName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.brandName} onFilter={(brandName) => onFilter({ brandName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      width: 120,
      Cell: (row) => PRODUCT_STATUS_TEXT[row.value] || '-',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(PRODUCT_STATUS_SELECT_LIST)}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'storeStatus',
      Header: '브랜드 상태',
      filterable: true,
      width: 120,
      Cell: (row) => STORE_STATUS_TEXT[row.value] || '-',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(STORE_ACTIVE_STATUS_SELECT_LIST)}
          onChange={(storeStatus) => onFilter({ storeStatus })}
          defaultValue={filterOption.storeStatus}
          value={filterOption.storeStatus}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'productNumber',
      Header: '제품번호',
    },
    {
      accessor: 'originPrice',
      Header: '판매가(원)',
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountPrice',
      Header: '할인가(원)',
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountRate',
      Header: '할인율',
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value, '%'),
    },
    {
      accessor: 'discountType',
      Header: '할인설정',
      Cell: (row) => setDash(DISCOUNT_TYPE_TEXT[row.value]),
    },
    {
      accessor: 'discountedPrice',
      Header: '할인된 판매가(원)',
      sortable: true,
      width: 120,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'salesPrice',
      Header: '실판매가',
      sortable: true,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountStartDate',
      Header: '할인 시작일',
      sortable: true,
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'discountEndDate',
      Header: '할인 종료일',
      sortable: true,
      width: 160,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'createDate',
      Header: '상품 등록일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      accessor: 'updateDate',
      Header: '최종 수정일',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.updateDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ updateDate: data })}
        />
      ),
    },
  ];
};

export default columns;
